import Honeybadger from '@honeybadger-io/js';

// NOTE: We don't want to initialize Honeybadger in non-prod mode most of the time
const shouldInitializeHoneybadger = process.env.REACT_APP_HONEYBADGER_API_KEY;

let honeybadger: null | Honeybadger = null;

export const initMonitoring = () => {
  if (!shouldInitializeHoneybadger) return;
  console.info('Initializing Honeybadger');

  honeybadger = Honeybadger.configure({
    apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY,
    enableUnhandledRejection: false,
    environment: process.env.NODE_ENV,
    revision: process.env.SOURCE_VERSION,
  });
};

export const notifyMonitoring = (error: string | Error) => {
  if (honeybadger) {
    honeybadger.notify(error, {
      message: typeof error === 'string' ? error : error.message,
    });
  } else {
    console.warn(error);
  }
};
